import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import BulkDeleteProcessingFeesModal from '@modals/BulkDeleteProcessingFeesModal'
import CreateOrEditProcessingFeeModal from '@modals/CreateOrEditProcessingFeeModal'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import type {
  ShowBulkDeleteProcessingFeesModalPayload,
  ShowCreateOrEditProcessingFeeModalPayload,
} from '@hooks/useProcessingFee'

import PageContent from './components/PageContent'

const defaultState = {
  showBulkDeleteProcessingFeesModal: false,
  showCreateOrEditProcessingFeeModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    BulkDeleteProcessingFeesModal: {
      bulkDeleteProcessingFees: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      closeModal: () => setState({ showBulkDeleteProcessingFeesModal: false }),
    },
    CreateOrEditProcessingFeeModal: {
      closeModal: () => setState({ showCreateOrEditProcessingFeeModal: false }),
      createOrUpdateProcessingFee: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      deleteProcessingFee: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)

  const {
    showBulkDeleteProcessingFeesModal,
    showCreateOrEditProcessingFeeModal,
  } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const pageContext = useMemo(() => ({
    callbacks: {
      deleteProcessingFee: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      showBulkDeleteProcessingFeesModal: (payload: ShowBulkDeleteProcessingFeesModalPayload) => {
        setModalData('CreateOrEditProcessingFeeModal', payload)
        setState({ showBulkDeleteProcessingFeesModal: true })
      },
      showCreateOrEditProcessingFeeModal: (payload: ShowCreateOrEditProcessingFeeModalPayload) => {
        setModalData('CreateOrEditProcessingFeeModal', payload)
        setState({ showCreateOrEditProcessingFeeModal: true })
      },
      ...filterCallbacks,
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <BulkDeleteProcessingFeesModal
          // @ts-expect-error TS2322
          callbacks={callbacks('BulkDeleteProcessingFeesModal', setState)}
          showModal={showBulkDeleteProcessingFeesModal}
        />

        <CreateOrEditProcessingFeeModal
          // @ts-expect-error TS2322
          callbacks={callbacks('CreateOrEditProcessingFeeModal', setState)}
          showModal={showCreateOrEditProcessingFeeModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
